/**
 * Utility functions for crop data processing
 */

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const getMonthIndex = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? null : date.getMonth();
};

export const getGrowthTime = (crop) => {
  if (crop.harvest_min_days && crop.harvest_max_days) {
    if (crop.harvest_min_days !== crop.harvest_max_days) {
      return `${crop.harvest_min_days} - ${crop.harvest_max_days} days`;
    }
    return `${crop.harvest_min_days} days`;
  }
  if (crop.harvest_min_days) return `${crop.harvest_min_days} days`;
  if (crop.harvest_max_days) return `${crop.harvest_max_days} days`;
  return "N/A";
};

export const formatDateRange = (start, end) => {
  if (start !== null && end !== null) {
    return `${monthNames[start]} to ${monthNames[end]}`;
  }
  return "N/A";
};

export const getWindowDates = (crop, periodType) => {
  const windows = (crop.crop_windows || []).filter(w => w.period_type === periodType);
  if (windows.length === 0) return { start: null, end: null };
  return {
    start: getMonthIndex(windows[0].window_start),
    end: getMonthIndex(windows[0].window_end)
  };
};

export const getWindowIntervals = (crop, periodType) => {
  const windows = (crop.crop_windows || []).filter((w) => w.period_type === periodType);
  return windows
    .map((w) => ({
      start: getMonthIndex(w.window_start),
      end: getMonthIndex(w.window_end),
    }))
    .filter((i) => i.start !== null && i.end !== null);
};

export const getAllWindowRanges = (crop) => {
  return {
    preGermination: getWindowIntervals(crop, "pre_germination"),
    directSowing: getWindowIntervals(crop, "direct_sowing"),
    setting: getWindowIntervals(crop, "setting"),
    planting: getWindowIntervals(crop, "planting"),
    pruning: getWindowIntervals(crop, "pruning"),
    harvest: getWindowIntervals(crop, "harvest"),
    picking: getWindowIntervals(crop, "picking"),
  };
};

export const getAllWindowDates = (crop) => {
  const preGerm = getWindowDates(crop, "pre_germination");
  const sowing = getWindowDates(crop, "direct_sowing");
  const setting = getWindowDates(crop, "setting");
  const planting = getWindowDates(crop, "planting");
  const pruning = getWindowDates(crop, "pruning");
  const harvest = getWindowDates(crop, "harvest");
  const picking = getWindowDates(crop, "picking");

  return {
    preGerminationStart: preGerm.start,
    preGerminationEnd: preGerm.end,
    directSowingStart: sowing.start,
    directSowingEnd: sowing.end,
    settingStart: setting.start,
    settingEnd: setting.end,
    plantingStart: planting.start,
    plantingEnd: planting.end,
    pruningStart: pruning.start,
    pruningEnd: pruning.end,
    harvestStart: harvest.start,
    harvestEnd: harvest.end,
    pickingStart: picking.start,
    pickingEnd: picking.end,
  };
};



